
const TextStyle = {
  headerText: {
    fontFamily: 'Schibsted Grotesk, sans-serif',
    fontSize:'18px',
    fontWeight: 500, 
  },
  errorText: {
    fontFamily: 'Schibsted Grotesk, sans-serif',
    fontSize:'14px',
    fontWeight: 500, 
    color: '#FF5E56',
  },
  successText: {
    fontFamily: 'Schibsted Grotesk, sans-serif',
    fontSize:'14px',
    fontWeight: 500, 
    color: '#33DA7F',
  },
};

const PageStyle = {
  container: {
    bgcolor: 'transparent',
  },
};

const ButtonStyle = {
  gradientBorder: {
    position: 'relative',
    borderImageSlice: 1,
    textTransform: 'none',
    borderRadius: '4px',
    height: '3rem',
    fontFamily: 'Schibsted Grotesk',
    fontWeight: 600,
    fontSize: '1rem',
    color: 'black',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: '6px',
      padding: '.2rem',
      background: 'linear-gradient(270deg, #00CECF 0%, #2449FC 100%)',
      WebkitMask:
        'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      maskComposite: 'exclude',
    },
    '&:hover': {
      background: 'linear-gradient(270deg, #00CECF 0%, #2449FC 100%)',
      color: 'white',
    },
  },
};

const customScrollbarStyle = {
  overflow: 'auto',
  '::-webkit-scrollbar': {
    width: '10px',
  },
  '::-webkit-scrollbar-track': {
    background: 'transparen',
  },
  '::-webkit-scrollbar-thumb': {
    bgcolor: 'rgba(155, 155, 155, 0.5)',
    borderRadius: ' 20px',
    border: ' transparent',
  },
};

const textFieldStyles = {
  fieldStyle: {
    width: '100%',
    height: '46px',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 20px',
    flexGrow: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    borderRadius: '6px',
  },
  activeFieldStyle: {
    backgroundColor: 'white',
    border: '1px solid black',
  },
};


export { TextStyle, PageStyle, ButtonStyle, customScrollbarStyle, textFieldStyles };